import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatError, MatInput, MatFormField } from '@angular/material/input';
import { MatOption, MatSelect } from '@angular/material/select';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { ReserveLoadingComponent } from '../../reserve-loading/reserve-loading.component';
import { BodyPainSelectorComponent } from '../../../shared/components/body-pain-selector/body-pain-selector.component';
import { MatCheckbox } from '@angular/material/checkbox';
import { Validators } from '@angular/forms';
import { FormsService } from '../forms.service';
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from '@angular/material/datepicker';
import { TagComponent } from '../../../shared/components/tag/tag.component';
import { TextComponent } from '../../../shared/components/text/text.component';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';

interface QuestionItem {
  sortNo: number;
  questionId: number;
  questionName: string;
  description: string;
  questionType: string;
  choiceList: Array<{
    sortNo: number;
    choiceId: string;
    choiceName: string;
    description: string;
    choiceValue: string;
  }>;
}
// 定義標題結構
interface GroupTitleConfig {
  title: string;
  subtitle: string;
}
interface ShowInputRule {
  triggerQuestionId: number;   // 觸發題
  triggerChoiceId: string;     // 觸發選項
  targetQuestionId?: number;    // 要顯示的 input 題
  targetQuestionId2?: number;    // 要顯示的 input 題
  targetQuestionId3?: number;    // 要顯示的 input 題
  targetQuestionIds?: number[];
}
@Component({
  selector: 'app-form-detail',
  imports: [CommonModule, ReactiveFormsModule, MatButtonModule, MatInput, MatError, MatRadioGroup,
    MatRadioButton, ReserveLoadingComponent, BodyPainSelectorComponent, MatCheckbox, MatFormField,
    MatOption, MatSelect, MatDatepicker, MatDatepickerInput, MatDatepickerToggle, TagComponent, TextComponent],
  templateUrl: './form-detail.component.html',
  styleUrl: './form-detail.component.scss'
})
export class FormDetailComponent implements OnInit, OnChanges {
  constructor(
    public formsService: FormsService,
    private toastrService: ToastrService
  ) {

  }
  ngOnChanges(changes: SimpleChanges): void {
    // 當 cardIndex 發生改變時

    if (changes['cardIndex'] && !changes['cardIndex'].firstChange) {
      this.getWorkloadTitle(this.questionnaireTypeId)
      // 可以在這裡強制重新驗證所有欄位，確保舊卡片的驗證不會帶到新卡片
      this.answerGroups.forEach(group => {
        const ctrl = group.get('answer');
        ctrl?.updateValueAndValidity();
      });
    }
  }
  showHealthInputRules: ShowInputRule[] = [
    { triggerQuestionId: 472, triggerChoiceId: '1538', targetQuestionId: 473 }, // 自覺症狀 -> 請輸入您的症狀
    { triggerQuestionId: 474, triggerChoiceId: '1564', targetQuestionId: 475 }, // 骨折
    { triggerQuestionId: 474, triggerChoiceId: '1565', targetQuestionId: 476 }, // 癌症
    { triggerQuestionId: 474, triggerChoiceId: '1566', targetQuestionId: 477 }, // 其他慢性疾病
    { triggerQuestionId: 474, triggerChoiceId: '1567', targetQuestionId: 478 }, // 其他
    { triggerQuestionId: 483, triggerChoiceId: '1610', targetQuestionId: 484 }, // 家族病史 -> 其他
    { triggerQuestionId: 511, triggerChoiceId: '1679', targetQuestionId: 512 }, // 常住國家 -> 其他
    { triggerQuestionId: 515, triggerChoiceId: '1698', targetQuestionId: 516 }, // 職位 -> 其他
    { triggerQuestionId: 519, triggerChoiceId: '1720', targetQuestionId: 520 }, // 曾經從事行業 -> 其他
    { triggerQuestionId: 523, triggerChoiceId: '1742', targetQuestionId: 524 }, // 目前從事行業 -> 其他
  ];
  operationInputRules: ShowInputRule[] = [
    { triggerQuestionId: 479, triggerChoiceId: '1573', targetQuestionId: 480 }, // 手術史或重大外傷
    { triggerQuestionId: 481, triggerChoiceId: '1590', targetQuestionId: 482 }//長期服藥 -> 其他

  ]
  showHobbyInputRules: ShowInputRule[] = [
    { triggerQuestionId: 485, triggerChoiceId: '1614', targetQuestionId: 486, targetQuestionId2: 487 }, //最近六個月內是否有嚼食檳榔
    { triggerQuestionId: 485, triggerChoiceId: '1615', targetQuestionId: 488, targetQuestionId2: 489 },
    { triggerQuestionId: 490, triggerChoiceId: '1622', targetQuestionId: 491, targetQuestionId2: 492 }, //過去一個月內是否有吸菸
    { triggerQuestionId: 490, triggerChoiceId: '1623', targetQuestionId: 493, targetQuestionId2: 494 },
    { triggerQuestionId: 495, triggerChoiceId: '1630', targetQuestionId: 496, targetQuestionId2: 497, targetQuestionId3: 498 }, //過去一個月內是否有喝酒
    { triggerQuestionId: 495, triggerChoiceId: '1631', targetQuestionId: 499, targetQuestionId2: 500 },
    { triggerQuestionId: 502, triggerChoiceId: '1643', targetQuestionIds: [507, 508, 509, 510] },
    { triggerQuestionId: 502, triggerChoiceId: '1644', targetQuestionIds: [503, 504, 505] },
  ]
  showOtherInputRules: ShowInputRule[] = [
    { triggerQuestionId: 511, triggerChoiceId: '1679', targetQuestionId: 512 }, //常住國家其他
    { triggerQuestionId: 515, triggerChoiceId: '1698', targetQuestionId: 516, },//職位

  ]
  showWorkInputRules: ShowInputRule[] = [
    { triggerQuestionId: 519, triggerChoiceId: '1720', targetQuestionId: 520 }, //請填寫曾經從事行業
    { triggerQuestionId: 523, triggerChoiceId: '1742', targetQuestionId: 524 }, //請填寫目前從事行業
    { triggerQuestionId: 527, triggerChoiceId: '1747', targetQuestionId: 528 }, //是否需要輪班
    { triggerQuestionId: 528, triggerChoiceId: '1751', targetQuestionId: 529 }, //是否需要輪班
  ]
  card4GroupTitles: { [key: number]: GroupTitleConfig } = {
    0: {
      title: '作業經歷',
      subtitle: '曾經從事的作業經歷'
    },
    1: {
      title: '作業經歷',
      subtitle: '目前從事的作業經歷'
    }
  };
  @Input() questionPlaceholders: { [key: number]: string } = {};
  @Input() questions: QuestionItem[] = [];
  @Input() answerGroups: FormGroup[] = [];
  @Input() groupIndex = 0;
  @Input() groupCount = 0;
  @Input() groupedQuestions: QuestionItem[][] = [];
  @Input() totalQuestions = 0;
  @Input() questionnaireTypeId = '';
  @Input() cardIndex = 0;//第幾張卡片
  @Input() questionErrorMessages: { [key: number]: { [key: string]: string } } = {};
  untilNow: any;
  canShowHobbyInput: boolean = false//是否可以開啟健調表條件
  isLoading: boolean = false//loading狀態
  hasInvalid: boolean = false;//檢核狀態
  noneChecked: boolean = false;//勾選狀態
  showTextMap: { [questionId: number]: boolean } = {};
  showText: boolean = false;
  today = new Date();
  checkAnswerList: string[] = [];
  otherCheckList: string[] = ['1538', '1564', '1565', '1566'];
  @Output() navigationChange = new EventEmitter<{ direction: 'prev' | 'next' | 'submit'; index?: number }>();
  @Output() otherAnswerChange = new EventEmitter<boolean>();// 用於通知父組件其他選項的變更

  getGroup(questionId: number): FormGroup | null {
    return this.answerGroups.find(
      g => g.get('questionId')?.value === questionId
    ) || null;
  }
  ngOnInit(): void {
    console.log(this.untilNow)
    this.formsService.loading$.subscribe(state => {
      this.isLoading = state;
    });
  }
  prevQuestion(): void {
    if (this.groupIndex > 0) {
      this.navigationChange.emit({ direction: 'prev' });
    }
  }

  // 獲取 "以下皆無" 選項
  getNoneOption(q: QuestionItem) {
    return q.choiceList.find(c => (c.sortNo === 1 && c.choiceName.includes('以下皆無')) || c.sortNo === 1 && c.choiceName.includes('無'));
  }
  // 獲取非 "以下皆無" 的選項
  getNormalOptions(q: QuestionItem) {
    return q.choiceList.filter(c => !(c.sortNo === 1 && c.choiceName.includes('無')));
  }

  nextQuestion(): void {
    // 1. 如果是問卷類型 2 且是第一頁，跳過檢核
    if (this.questionnaireTypeId === '2' && (this.groupIndex === 0 || this.groupIndex === 5)) {
      this.navigationChange.emit({ direction: 'next' });
      return;
    }

    // 2. 標記所有欄位為 touched 以顯示紅字
    this.answerGroups.forEach(group => group.markAllAsTouched());
    console.log(this.answerGroups)
    // 3. 找出無效的欄位
    this.hasInvalid = this.answerGroups.some((group, index) => {
      const answerCtrl = group.get('answer');
      // 如果被禁用，不視為 invalid
      if (answerCtrl?.disabled) return false;

      if (group.invalid) {
        // 🔥 在這裡下 Console.log
        console.warn(`第 ${index} 題驗證失敗:`, {
          questionId: group.get('questionId')?.value,
          errors: group.get('answer')?.errors,    // 印出具體的錯誤類型 (如 required)
          value: group.get('answer')?.value,      // 印出目前填寫的值
          group: group                            // 完整的 FormGroup 物件方便檢查
        });
        return true; // 找到第一個無效欄位就停止迴圈
      }
      return false;
    });

    if (this.hasInvalid) {
      console.error('表單含有無效欄位，無法切換至下一步');
      return;
    }
    const startDate = this.getAnswerByQuestionId(521);
    const endDate = this.getAnswerByQuestionId(522);

    if (startDate > endDate) {
      this.toastrService.warning('截止日期需大於起始日期!')
      return
    }

    this.navigationChange.emit({ direction: 'next' });
  }
  submit(): void {
    this.answerGroups.forEach(group => group.markAllAsTouched());

    // 找出所有無效的群組
    const invalidGroups = this.answerGroups.filter(group => group.invalid);

    if (invalidGroups.length > 0) {
      console.log('--- 表單驗證失敗清單 ---');
      invalidGroups.forEach((group, index) => {
        // 取得題目 ID (對應你 questions 陣列中的資訊)
        const qId = group.get('questionId')?.value;
        // 找出該 ID 對應的題目名稱（這能幫助你一眼看出是哪一題）
        const qName = this.questions.find(q => q.questionId === qId)?.questionName;
        // 取得具體的錯誤內容
        const errors = group.get('answer')?.errors;
        console.error(`題目 ID: ${qId}`);
        console.error(`題目名稱: ${qName}`);
        console.error(`錯誤原因:`, errors);
        console.log('-----------------------');
      });

      return; // 攔截提交
    }
    const workStartDate = this.getAnswerByQuestionId(525);
    const workEndDate = this.getAnswerByQuestionId(526);
    if (workStartDate > workEndDate) {
      this.toastrService.warning('截止日期需大於起始日期!')
      return
    }
    // 提交表單邏輯
    this.navigationChange.emit({ direction: 'submit', index: this.cardIndex });
  }
  //塞入答案choiceIdId到answer裡面
  getChoiceId(choiceId: any, answerGroups: FormGroup): void {
    answerGroups.get('choiceId')?.setValue(choiceId);
  }
  //將下來選單塞入答案choiceIdId到answer裡面
  getChoiceIdBySortNo(sortNo: number, answerGroup: FormGroup, q: QuestionItem): void {
    const selected = q.choiceList.find(c => c.sortNo === sortNo);
    console.log(selected)
    answerGroup.get('choiceId')?.setValue(selected?.choiceId ?? '');
  }

  onDateChange(event: any, group: FormGroup, q: QuestionItem): void {
    // 1. 強制轉為 Date 物件（不論傳入的是字串還是 Date）
    const dateValue = event.value;
    const selectedDate = dateValue ? new Date(dateValue) : null;

    // 2. 檢查 selectedDate 是否為有效的日期物件 (防止 invalid date)
    if (selectedDate && !isNaN(selectedDate.getTime()) && q.choiceList?.length > 0) {
      // 3. 取得該日期題對應的 choiceId
      const choiceId = q.choiceList[0].choiceId;
      // 4. 轉換日期格式為 YYYYMMDD
      const y = selectedDate.getFullYear();
      const m = (selectedDate.getMonth() + 1).toString().padStart(2, '0');
      const d = selectedDate.getDate().toString().padStart(2, '0');
      const formattedDate = `${y}${m}${d}`;

      // 5. 將結果塞入 FormGroup
      // 使用 patchValue 並關閉 emitEvent 防止無窮迴圈
      group.patchValue({
        answer: formattedDate,
        choiceId: choiceId
      }, { emitEvent: false });

    }
  }
  // 獲取必填錯誤訊息
  getRequiredErrorMsg(q: QuestionItem): string {
    const found = q.choiceList.find(c => (c.description || '').includes('必填'));
    return '此欄位為必填';
  }


  // 判斷選項是否被選中
  isChecked(choiceId: string, group: FormGroup | null): boolean {
    if (!group) return false;
    const value = group.get('answer')?.value || [];
    return Array.isArray(value) && value.includes(choiceId);
  }

  // 判斷 "以下皆無" 是否被選中
  isNoneSelected(group: FormGroup, q: QuestionItem): boolean {
    const noneOption = this.getNoneOption(q);
    if (!noneOption) return false;

    const value = group.get('answer')?.value || [];
    return Array.isArray(value) && value.includes(noneOption.choiceId);
  }
  // 處理 "以下皆無" 選項的變更
  onNoneChange(
    checked: boolean,
    choiceId: string,
    group: FormGroup,
    q: QuestionItem
  ): void {
    const control = group.get('answer');
    console.log(group.get('choiceId'))
    // 如果 "以下皆無" 被選中，直接設置 answer 為該選項的 ID；如果取消選中，則清空 answer
    if (checked) {
      control?.setValue([choiceId]);
      console.log(control?.value)
    }
    else {
      control?.setValue([]);
    }
    //如果選擇其他
    control?.markAsTouched();
  }
  // 處理其他選項的變更
  onCheckboxChange(
    checked: boolean,
    choiceId: string,
    group: FormGroup,
    q?: QuestionItem
  ): void {
    const control = group.get('answer');
    const currentValue = control?.value || [];
    let nextValue = Array.isArray(currentValue) ? [...currentValue] : [];

    const noneOption = q ? this.getNoneOption(q) : undefined;
    if (noneOption) {
      nextValue = nextValue.filter(id => id !== noneOption.choiceId);
    }

    const rule = this.showHealthInputRules.find(r =>
      r.triggerQuestionId === group.get('questionId')?.value &&
      r.triggerChoiceId === choiceId
    );

    if (checked) {
      if (!nextValue.includes(choiceId)) {
        nextValue.push(choiceId);
      }

      // 🔥 勾選 → input 變必填
      if (rule) {
        const targetGroup = this.answerGroups.find(g =>
          g.get('questionId')?.value === rule.targetQuestionId
        );

        if (targetGroup) {
          const inputCtrl = targetGroup.get('answer');
          inputCtrl?.setValidators([Validators.required]);
          inputCtrl?.updateValueAndValidity();
        }
      }

    } else {
      nextValue = nextValue.filter((id: string) => id !== choiceId);
      if (rule) {
        // 🔥 檢查是否還有其他 trigger
        const stillChecked = nextValue.some(id =>
          this.showHealthInputRules.some(r =>
            r.triggerQuestionId === group.get('questionId')?.value &&
            r.triggerChoiceId === id &&
            r.targetQuestionId === rule.targetQuestionId
          )
        );
        const targetGroup = this.answerGroups.find(g =>
          g.get('questionId')?.value === rule.targetQuestionId
        );
        if (targetGroup) {
          const inputCtrl = targetGroup.get('answer');
          if (!stillChecked) {
            // ❌ 沒勾 → 移除 required + 清值
            inputCtrl?.clearValidators();
            inputCtrl?.setValue('');
          }
          inputCtrl?.updateValueAndValidity();
        }
      }
    }
    control?.setValue(nextValue);
    control?.markAsTouched();
  }

  shouldShowInput(q: QuestionItem): boolean {
    // 1. 取得當前題目的 FormGroup
    const currentGroup = this.answerGroups.find(g =>
      g.get('questionId')?.value === q.questionId
    );
    if (!currentGroup) return false;

    // 2. 根據 cardIndex 挑選規則集 (保持原邏輯)
    const activeRulesMap: { [key: number]: ShowInputRule[] } = {
      0: this.showHealthInputRules,
      1: this.operationInputRules,
      2: this.showHobbyInputRules,
      3: this.showOtherInputRules,
      4: this.showWorkInputRules
    };
    const activeRules = activeRulesMap[this.cardIndex] || [];
    if (this.cardIndex === 2) this.canShowHobbyInput = true;

    // 3. 尋找規則
    const rule = activeRules.find(r =>
      r.targetQuestionId === q.questionId ||
      r.targetQuestionId2 === q.questionId ||
      r.targetQuestionId3 === q.questionId ||
      (r.targetQuestionIds && r.targetQuestionIds.includes(q.questionId))
    );

    // 4. 處理邏輯優先權
    if (!rule) return q.questionType === '1';

    // 5. 執行規則觸發判斷
    const triggerGroup = this.answerGroups.find(group =>
      group.get('questionId')?.value === rule.triggerQuestionId
    );
    if (!triggerGroup) return false;

    const answerValue = triggerGroup.get('answer')?.value;
    const selectedChoiceId = triggerGroup.get('choiceId')?.value;

    let shouldShow = Array.isArray(answerValue)
      ? answerValue.includes(rule.triggerChoiceId)
      : selectedChoiceId == rule.triggerChoiceId;

    // 6. 【核心修正】智慧同步 Validators 
    const inputCtrl = currentGroup.get('answer');
    if (!inputCtrl) return shouldShow;

    // 如果 Registry 裡還沒有這題，就把目前控制項上的驗證器存進去 (避免蓋掉初始值)
    if (!this.formsService.questionValidatorRegistry[q.questionId] && inputCtrl.validator) {
      this.formsService.questionValidatorRegistry[q.questionId] = {
        validators: [inputCtrl.validator],// 保存初始驗證器[cite: 5]
        errorMessages: {
          required: '此欄位為必填' // 提供預設錯誤訊息，或從 QuestionItem 取得
        }
      };
    }

    const originalConfig = this.formsService.questionValidatorRegistry[q.questionId];
    const originalValidators = originalConfig?.validators || [];

    if (shouldShow) {
      // 顯示時：恢復原始驗證
      inputCtrl.setValidators(originalValidators);
    } else {
      // 隱藏時：清空驗證並清空值
      inputCtrl.clearValidators();
      if (inputCtrl.value !== '' && inputCtrl.value !== null) {
        inputCtrl.setValue('', { emitEvent: false });
      }
    }

    // 強制更新狀態，但不觸發全域 valueChanges 以免死結
    inputCtrl.updateValueAndValidity({ emitEvent: false });

    return shouldShow;
  }
  getAnswerByQuestionId(questionId: number): any {
    const group = this.answerGroups.find(g =>
      g.get('questionId')?.value === questionId
    );

    return group?.get('answer')?.value;
  }

  onUntilNowChange(checked: boolean, group: FormGroup): void {
    const questionId = group.get('questionId')?.value;
    const answerCtrl = group.get('answer');

    // 👉 只處理 526
    if (questionId !== 526) return;
    if (checked) {
      // 🔥 帶入今天日期
      const today =moment().format('YYYYMMDD');
      answerCtrl?.setValue(today);
      // 🔥 disabled
      answerCtrl?.disable({ emitEvent: false });
    } else {
      // 🔥 取消勾選 → 開啟欄位
      answerCtrl?.enable({ emitEvent: false });
      answerCtrl?.setValue('');
    }
    answerCtrl?.updateValueAndValidity({ emitEvent: false });
  }

  // 輔助方法：獲取控制項目前的錯誤 key (例如 'required')
  getErrorKeys(control: any): string[] {
    if (!control?.errors) return [];
    return Object.keys(control.errors);
  }

  getErrorMessage(q: QuestionItem, errorKey: string): string {
    return this.questionErrorMessages[q.questionId]?.[errorKey] || '此欄位有誤';
  }
  /**
   * 取得過勞分量表標題
   * @param questionId 題目的 ID 或 sortNo (根據您的資料結構調整)
   */
  getWorkloadTitle(typeId: string): string {
    if (typeId === '1') {
      const page = this.groupIndex + 1;
      if (page >= 2 && page <= 7) return this.formsService.workloadList[0];
      if (page >= 8 && page <= 14) return this.formsService.workloadList[1];
      return '';
    }
    // --- 類型 3：健康調查表標題邏輯 ---
    if (typeId === '3') {
      // 如果有對應的標題則回傳，否則回傳空字串
      return this.formsService.healthTitles[this.cardIndex] || '';
    }
    return '';
  }
}
